import { createFrontendModule } from '@backstage/frontend-plugin-api'
import {
  HomePageLayoutBlueprint,
  HomePageWidgetBlueprint,
} from '@backstage/plugin-home-react/alpha'

const layout = HomePageLayoutBlueprint.make({
  params: {
    loader: async () => (await import('./components/HomeLayout')).HomeLayout,
  },
})

const pulse = HomePageWidgetBlueprint.make({
  name: 'dg-pulse',
  params: {
    name: 'DgPulse',
    title: 'Platform pulse',
    description: 'Request rate, error rate and p95 latency per environment',
    components: async () => ({
      Content: (await import('./components/PulseWidget')).PulseContent,
    }),
  },
})

const alerts = HomePageWidgetBlueprint.make({
  name: 'dg-alerts',
  params: {
    name: 'DgAlerts',
    title: 'Firing alerts',
    description: 'Active, unsilenced Alertmanager alerts',
    components: async () => ({
      Content: (await import('./components/AlertsWidget')).AlertsContent,
    }),
  },
})

const topServices = HomePageWidgetBlueprint.make({
  name: 'dg-top-services',
  params: {
    name: 'DgTopServices',
    title: 'Busiest PROD services',
    description: 'Top services by request rate, last 15 minutes',
    components: async () => ({
      Content: (await import('./components/ServiceWidgets')).TopServicesContent,
    }),
  },
})

const myServices = HomePageWidgetBlueprint.make({
  name: 'dg-my-services',
  params: {
    name: 'DgMyServices',
    title: "Your teams' services",
    description: 'Everything owned by the groups you belong to',
    components: async () => ({
      Content: (await import('./components/ServiceWidgets')).MyServicesContent,
    }),
  },
})

const catalogHealth = HomePageWidgetBlueprint.make({
  name: 'dg-catalog-health',
  params: {
    name: 'DgCatalogHealth',
    title: 'Catalog health',
    description: 'Completeness and service.yaml adoption',
    components: async () => ({
      Content: (await import('./components/ServiceWidgets'))
        .CatalogHealthContent,
    }),
  },
})

const quickLinks = HomePageWidgetBlueprint.make({
  name: 'dg-quick-links',
  params: {
    name: 'DgQuickLinks',
    title: 'Tools and knowledge',
    description: 'Links from dgHome.linkGroups',
    components: async () => ({
      Content: (await import('./components/QuickLinks')).QuickLinksContent,
    }),
  },
})

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [
    layout,
    pulse,
    alerts,
    topServices,
    myServices,
    catalogHealth,
    quickLinks,
  ],
})
